import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveFarmUser: ['farmUser', 'onSuccess', 'onError'],
  removeFarmUser: ['farmUser', 'onSuccess', 'onError'],
  farmUserError: ['error']
})

const saveFarmUser = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeFarmUser = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const farmUserError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.FARM_USER_ERROR]: farmUserError,

  [Types.SAVE_FARM_USER]: saveFarmUser,
  [Types.REMOVE_FARM_USER]: removeFarmUser,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as FarmUserTypes,
  Creators as FarmUserActions
}
